import React from 'react';
import { Lock, ShoppingBag, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

// A store can be closed for two unrelated reasons, and they read very
// differently to a customer: an administrator suspending the funeral home, or
// the funeral home simply not being on e-Displayroom any more. "Suspended" is
// the wrong — and unfairly alarming — thing to say about the second.
const REASON_COPY = {
    STORE_SUSPENDED: {
        title: 'Store Temporarily Unavailable',
        body: 'This store is currently unavailable. Please contact the store owner for more information.'
    },
    MODULE_DISABLED: {
        title: 'Store Not Currently Open',
        body: 'This store is not accepting orders at the moment. Please contact the funeral home directly.'
    }
};

export default function StoreBlocked({ theme = {}, reason = 'STORE_SUSPENDED' }) {
    const primaryColor = theme.primary_color || "#1a365d";
    const font = theme.font_family || "Inter, sans-serif";
    const copy = REASON_COPY[reason] || REASON_COPY.STORE_SUSPENDED;

    return (
        <div
            className="min-h-screen flex items-center justify-center p-4 bg-slate-50"
            style={{ fontFamily: font }}
        >
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border overflow-hidden p-8 text-center space-y-6">
                <div
                    className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4"
                    style={{ backgroundColor: `${primaryColor}10` }}
                >
                    <Lock className="w-10 h-10" style={{ color: primaryColor }} />
                </div>

                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-slate-900">{copy.title}</h1>
                    <p className="text-slate-600">{copy.body}</p>
                </div>

                <div className="pt-4 flex flex-col gap-3">
                    <Button
                        onClick={() => window.location.href = '/'}
                        className="w-full gap-2"
                        style={{ backgroundColor: primaryColor }}
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to Main Store
                    </Button>
                    <p className="text-xs text-slate-400">
                        &copy; {new Date().getFullYear()} eDisplayroom. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    );
}
